import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './InProgButton.module.css';
import { CommonButton } from '_components';


export class InProgButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'In-Progress'} onClick={this.props.onClick} size={this.props.size} className={cls} type='round' >
                <FontAwesomeIcon icon={faSpinner} color={this.props.color ? this.props.color : "#f7941d"} />
            </CommonButton>
        );
    }
}

